import React from 'react'
import Navbar from "../inc/Navbar";
import ScrollToTop from "react-scroll-to-top";

import { Link } from "react-router-dom";
import "./Blog.css";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import plotarea from "../images/land sale kolkata airport update.jpg";
import landinvest from "../images/land invest kolkata airport.jpg";






function Blog() {

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="Gray" />
            <div className='websitedevelopkrishnagar'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Blog Page</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>


            <div className='blogcolor'>
                <div className="album py-2">

                    <div className="container">
                        <br />
                        <h1 className='single-line-text mb-0'><b>Blog</b> Page</h1>
                        <div className="row">
                            <div className="col-md-3">
                                <hr className='mb-2' />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="album py-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={plotarea} alt="plotarea" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Own The Land</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Beneth Your Future Home</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='PlotsNear_KolkataAirport'>
                                                    <button className='unicornaerocitygreens_kolkata mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={landinvest} alt="landinvest" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Land Invest</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Your Future Home</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='PlotsNear_KolkataAirport'>
                                                    <button className='blog mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </Carousel>
                            </div>
                           
                        </div>
                    </div>

                </div>
                <br />
            </div>

        </div>
    )
}

export default Blog